//
// ReportMetadata.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "./ReportManifest";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var ReportMetadata = createModule("transport::ReportMetadata", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        regeneratePackage: 7,
        resourceId: 7,
        keywords: [7],
        displayName: 7,
        description: 7,
        type: 7,
        dataSetFileName: 7,
        path: 7,
        lastModifiedDatetime: 9,
        cachedReports: [1],
        printReport: 7,
        modifiedBy: 7,
        links: [1],
        regenerateDocument: 7,
        createdByUserId: 7,
        thumbnail: 7,
        created: 7,
        GUID: 7,
        createdBy: 7,
        createdDatetime: 9,
        location: 7,
        shareURL: 7,
        lastModified: 7,
        shortName: 7,
        modifiedByUserId: 7,
    },
    ,
    ,
    {
        createdUpdated: [0,1],
        lastModifiedUpdated: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default ReportMetadata;
